import { __decorate } from "tslib";
import { Component, Vue, Emit, Prop, Watch } from 'vue-property-decorator';
import taskTypeMessages from '@blade-sxp/task-management/lang/task-type';
let default_1 = class default_1 extends Vue {
    similarity = 0;
    sliderValue = 0;
    minNum = 0;
    maxNum = 100;
    getSimilarity() {
        this.sliderValue = this.similarity;
    }
    getSliderValue() {
        return this.sliderValue;
    }
    changeSilder(num) {
        this.getSliderValue();
    }
};
__decorate([
    Prop()
], default_1.prototype, "similarity", void 0);
__decorate([
    Watch('similarity')
], default_1.prototype, "getSimilarity", null);
__decorate([
    Emit('sliderValue')
], default_1.prototype, "getSliderValue", null);
default_1 = __decorate([
    Component({
        name: 'similarity-slider',
        components: {},
        i18n: {
            messages: taskTypeMessages,
        },
    })
], default_1);
export default default_1;
